import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconToolsSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width="20.629" height="20.629" viewBox="0 0 20.629 20.629"
            className={classNames(['svg-icon svg-tools', className])}>
            <path fill="none" d="M0,0H20.629V20.629H0Z"/>
            <path fill={color} d="M10.533,2.644a5.589,5.589,0,0,0-6.4-1.066L7.258,4.7a.856.856,0,0,1,0,1.212L5.891,7.277a.841.841,0,0,1-1.212,0l-3.12-3.12a5.581,5.581,0,0,0,7,7.659L15.4,18.657a2.255,2.255,0,1,0,3.189-3.189L11.779,8.652a5.594,5.594,0,0,0-1.246-6.008Z" transform="translate(-0.141 -0.142)"/>
        </svg>
    );
};

IconToolsSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconToolsSVG.defaultProps = {
    color: '#ffffff',
    className: '',
};

export default IconToolsSVG;